(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bokamera-event-booking"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('.boka').forEach((root) => {
    const endpoint = root.dataset.endpoint.replace(/\/$/, '');
    const form = root.querySelector('[data-form]');
    const error = root.querySelector('[data-error]');
    const errorText = root.querySelector('[data-error-text]');
    const success = root.querySelector('[data-success]');
    const timesEl = root.querySelector('[data-times]');
    const steps = root.querySelectorAll('[data-step-item]');
    let currentEvent, selectedSlot;

    const setStep = (n) => {
      root.querySelectorAll('[data-p]').forEach((panel) => { panel.hidden = panel.dataset.p != n; });
      steps.forEach((step) => {
        const stepNum = Number(step.dataset.stepItem);
        step.removeAttribute('aria-current');
        step.removeAttribute('data-complete');
        if (stepNum === n) step.setAttribute('aria-current', 'step');
        else if (stepNum < n) step.setAttribute('data-complete', 'true');
      });
      root.querySelector('.boka__inner').scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    };

    const showError = (message) => { errorText.textContent = message; error.hidden = false; };
    const hideError = () => { error.hidden = true; };

    root.querySelectorAll('[data-book]').forEach((button) => {
      button.addEventListener('click', () => {
        currentEvent = button.closest('[data-event]');
        selectedSlot = undefined;
        root.querySelector('[data-title]').textContent = currentEvent.dataset.title;
        timesEl.innerHTML = '<div class="boka__loading"><span class="boka__spinner"></span>Henter ledige tider …</div>';
        setStep(2);

        fetch(`${endpoint}/slots?event_id=${encodeURIComponent(currentEvent.dataset.eventId)}`, { headers: { Accept: 'application/json' } })
          .then((res) => (res.ok ? res.json() : Promise.reject()))
          .then((data) => {
            const slots = data.slots || [];
            if (!slots.length) { timesEl.innerHTML = '<p class="boka__slots-empty">Der er desværre ingen ledige pladser tilbage.</p>'; return; }

            const list = document.createElement('div');
            list.className = 'boka__slot-list';
            slots.forEach((slot) => {
              const btn = document.createElement('button');
              btn.type = 'button';
              btn.className = 'boka__slot';
              btn.setAttribute('role', 'radio');
              btn.setAttribute('aria-checked', 'false');
              const low = slot.remaining <= 3;
              btn.innerHTML = `
                <span class="boka__slot-radio" aria-hidden="true"></span>
                <span class="boka__slot-label">${slot.label}</span>
                <span class="boka__slot-remaining${low ? ' boka__slot-remaining--low' : ''}">${slot.remaining} ${slot.remaining === 1 ? 'plads' : 'pladser'} tilbage</span>
              `;
              btn.addEventListener('click', () => {
                selectedSlot = slot;
                root.querySelector('[data-race]').textContent = currentEvent.dataset.title;
                root.querySelector('[data-time]').textContent = slot.label;
                hideError();
                form.hidden = false;
                success.hidden = true;
                setStep(3);
              });
              list.appendChild(btn);
            });
            timesEl.innerHTML = '';
            timesEl.appendChild(list);
          })
          .catch(() => { timesEl.innerHTML = '<p class="boka__slots-empty">Tiderne kan ikke hentes lige nu. Prøv igen om et øjeblik.</p>'; });
      });
    });

    root.querySelectorAll('[data-back]').forEach((button) => {
      button.addEventListener('click', () => setStep(currentEvent ? (button.closest('[data-p]').dataset.p == 3 ? 2 : 1) : 1));
    });

    // The browser's own back button restores the page from its bfcache
    // instead of reloading it — without this, a customer who completed a
    // booking and then hit "back" lands on a page frozen mid-wizard (step
    // 2/3 markup left un-hidden, showing stray leftover title/subtitle text
    // above the event list) instead of the clean step-1 view.
    window.addEventListener('pageshow', (event) => {
      if (!event.persisted) return;
      currentEvent = undefined;
      selectedSlot = undefined;
      hideError();
      form.reset();
      form.hidden = false;
      success.hidden = true;
      setStep(1);
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      hideError();
      if (!selectedSlot) return showError('Vælg venligst et tidspunkt.');
      if (!form.reportValidity()) return;

      const submit = form.querySelector('[type="submit"]');
      const submitLabel = form.querySelector('[data-submit-label]');
      const submitSpinner = form.querySelector('[data-submit-spinner]');
      submit.disabled = true;
      submitLabel.textContent = 'Booker …';
      submitSpinner.hidden = false;

      const payload = Object.fromEntries(new FormData(form).entries());
      payload.event_id = currentEvent.dataset.eventId;
      payload.slot_id = selectedSlot.id;

      try {
        const res = await fetch(`${endpoint}/bookings`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload),
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.message || 'Din booking kunne ikke gennemføres.');
        form.hidden = true;
        root.querySelector('[data-success-email]').textContent = payload.email;
        success.hidden = false;
        steps.forEach((step) => { step.removeAttribute('aria-current'); step.setAttribute('data-complete', 'true'); });
      } catch (err) {
        showError(err.message || 'Der opstod en fejl. Prøv venligst igen.');
      } finally {
        submit.disabled = false;
        submitLabel.textContent = 'Bekræft booking';
        submitSpinner.hidden = true;
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["event-booking-run"] && !Shopify.designMode) return;
  try {
    
  (()=>{document.querySelectorAll('.event-booking-run').forEach((section)=>{const form=section.querySelector('.event-booking-run__form');const slots=section.querySelector('[data-slots]');const error=section.querySelector('[data-error]');const endpoint=section.dataset.endpoint.replace(/\/$/,'');let selectedSlot;const showError=(message)=>{error.textContent=message;error.hidden=false};const renderSlots=(items)=>{slots.innerHTML='';if(!items.length){slots.textContent='Der er desværre ingen ledige pladser tilbage.';return}items.forEach((item)=>{const button=document.createElement('button');button.className='event-booking-run__slot';button.type='button';button.setAttribute('role','radio');button.setAttribute('aria-checked','false');button.textContent=`${item.label} (${item.remaining} pladser)`;button.addEventListener('click',()=>{slots.querySelectorAll('button').forEach((slot)=>slot.setAttribute('aria-checked','false'));button.setAttribute('aria-checked','true');selectedSlot=item.id;error.hidden=true});slots.appendChild(button)})};fetch(`${endpoint}/slots?event_id=${encodeURIComponent(section.dataset.eventId)}`,{headers:{Accept:'application/json'}}).then((response)=>response.ok?response.json():Promise.reject()).then((data)=>renderSlots(data.slots||[])).catch(()=>{slots.textContent='Tiderne kan ikke hentes lige nu. Prøv igen om et øjeblik.'});form.addEventListener('submit',async(event)=>{event.preventDefault();error.hidden=true;if(!selectedSlot)return showError('Vælg venligst et starttidspunkt.');if(!form.reportValidity())return;const submit=form.querySelector('[type="submit"]');submit.disabled=true;const payload=Object.fromEntries(new FormData(form).entries());payload.event_id=section.dataset.eventId;payload.slot_id=selectedSlot;try{const response=await fetch(`${endpoint}/bookings`,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(payload)});const data=await response.json();if(!response.ok)throw new Error(data.message||'Din booking kunne ikke gennemføres.');form.hidden=true;section.querySelector('[data-email]').textContent=payload.email;section.querySelector('[data-success]').hidden=false}catch(requestError){showError(requestError.message||'Der opstod en fejl. Prøv venligst igen.')}finally{submit.disabled=false}})})})();

  } catch(e) { console.error(e); }
})();
})();
